import { __assign, __extends } from "tslib";
import * as React from 'react';
import { NavLink } from './NavLink';
import { NavLinkGroup } from './NavLinkGroup';
import { classNamesFunction } from 'office-ui-fabric-react';
import { warnDependent } from '@m365-admin/utilities';
import { NavTeachingBubble } from './NavTeachingBubble/NavTeachingBubble';
var getClassNames = classNamesFunction();
var NavGroupBase = /** @class */ (function (_super) {
    __extends(NavGroupBase, _super);
    function NavGroupBase(props) {
        var _this = _super.call(this, props) || this;
        _this._setLinkRef = function (linkItem) {
            // we do this with state because getting a ref is not synchronous
            // without this, a TeachingBubble will not show if showHeaderTeachingBubble is true initially
            if (_this.state.linkRef !== linkItem) {
                _this.setState({ linkRef: linkItem });
            }
        };
        _this.state = { linkRef: null };
        return _this;
    }
    NavGroupBase.prototype.render = function () {
        var _this = this;
        var _a = this.props, groupIndex = _a.groupIndex, onRenderGroupTitle = _a.onRenderGroupTitle, links = _a.links, isNavCollapsed = _a.isNavCollapsed, onCollapse = _a.onCollapse, navRef = _a.navRef, focusZoneRef = _a.focusZoneRef, styles = _a.styles, theme = _a.theme, showHeaderTeachingBubble = _a.showHeaderTeachingBubble, headerTeachingBubbleProps = _a.headerTeachingBubbleProps, itemStartIndex = _a.itemStartIndex, itemTotal = _a.itemTotal;
        var classNames = getClassNames(styles, { isNavCollapsed: isNavCollapsed, theme: theme });
        var defaultOnRenderGroupTitle = function (props) {
            if (props && props.groupName && !props.isNavCollapsed) {
                return React.createElement("span", { className: classNames.navGroupTitle }, props.groupName);
            }
            return null;
        };
        var groupTitle;
        if (onRenderGroupTitle) {
            groupTitle = React.createElement(React.Fragment, null, onRenderGroupTitle(this.props, defaultOnRenderGroupTitle));
        }
        else {
            groupTitle = defaultOnRenderGroupTitle(this.props);
        }
        return (React.createElement(React.Fragment, null,
            groupIndex !== 0 && React.createElement("li", { role: "presentation", className: classNames.navGroupDivider }),
            groupTitle && (React.createElement(React.Fragment, null,
                React.createElement("li", __assign({ role: "presentation" }, this.props.groupTitleAttributes, { ref: this._setLinkRef }), groupTitle),
                showHeaderTeachingBubble && (React.createElement(NavTeachingBubble, __assign({ target: this.state.linkRef }, headerTeachingBubbleProps))))),
            links.map(function (link, index) {
                // warn if developer passes in onExpanded without dependent links prop
                warnDependent('INavLink', link, { onExpanded: 'links' });
                var hasSelectedNestedLink = _this._isNestedLinkSelected(link);
                var setSize = itemStartIndex + index;
                return (
                // if there are nested links, render a NavLinkGroup, otherwise just render a NavLink
                React.createElement("li", { className: classNames.navItem, role: "presentation", key: link.key }, link.links ? (React.createElement(NavLinkGroup, __assign({}, link, { styles: link.navLinkGroupStyles, isNavCollapsed: isNavCollapsed, link: link, hasNestedMenu: true, hasSelectedNestedLink: hasSelectedNestedLink, onCollapse: onCollapse, navRef: navRef, focusZoneRef: focusZoneRef, itemStartIndex: setSize, itemTotal: itemTotal }))) : (React.createElement(NavLink, __assign({ item: link, primaryIconName: link.icon, role: "menuitem" }, link, { isNavCollapsed: isNavCollapsed }, (link.isSelected && { 'aria-current': 'page' }), { hasNestedMenu: false, isNested: false, "aria-posinset": setSize, "aria-setsize": itemTotal })))));
            })));
    };
    NavGroupBase.prototype._isNestedLinkSelected = function (link) {
        return (link &&
            !!link.links &&
            link.links.some(function (childLink) {
                return !!childLink && !!childLink.isSelected;
            }));
    };
    return NavGroupBase;
}(React.Component));
export { NavGroupBase };
//# sourceMappingURL=NavGroupBase.js.map